import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createUnits(data) {
  return axiosInstance.post(`admin/units/create`, formatRequest(data));
}

export function updateUnits(data) {
  return axiosInstance.post(`admin/units/update`, formatRequest(data));
}

export function getUnitsList(data) {
  return axiosInstance.post(`admin/units/list`, formatRequest(data));
}

export function getUnitsDetails(data) {
  return axiosInstance.post(`admin/units/details`, formatRequest(data));
}

export function deleteUnits(data) {
  return axiosInstance.post(`admin/units/delete`, formatRequest(data));
}
